module.exports = __webpack_public_path__ + "img/13.a530a4d2.jpg";